/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Terms_P2Inputs */

const en_register_onboarding_terms_p2 = /** @type {(inputs: Register_Onboarding_Terms_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I am aware that the matching provides guidance but does not constitute an automatic application or selection decision. Data processing is carried out in accordance with the data protection regulations of TU Darmstadt.`)
};

const de_register_onboarding_terms_p2 = /** @type {(inputs: Register_Onboarding_Terms_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich bin mir bewusst, dass das Matching eine Orientierung bietet, jedoch keine automatische Bewertung oder Auswahlentscheidung darstellt. Die Datenverarbeitung erfolgt gemäß den Datenschutzbestimmungen der TU Darmstadt.`)
};

/**
* | output |
* | --- |
* | "I am aware that the matching provides guidance but does not constitute an automatic application or selection decision. Data processing is carried out in acco..." |
*
* @param {Register_Onboarding_Terms_P2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_terms_p2 = /** @type {((inputs?: Register_Onboarding_Terms_P2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Terms_P2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_terms_p2(inputs)
	return en_register_onboarding_terms_p2(inputs)
});